import axios from "axios";
import {Component} from "react";
class ClickInfos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userip: null,
            data: []
        };
    }

    getUserIp = () => {

        axios.get(process.env.REACT_APP_API_URLSF+`/user/ip/`)
            .then(response =>{
                this.setState( {data: response.data} );
                this.state.userip = response.data
                console.log(this.state);
            })
            .catch(err => {
                console.error(err);
            });

        return null;
    }
}

export default ClickInfos;